import React, {Component} from 'react';
import Select from "react-select";

class CreateOrderExpireVpsComponent extends Component {

    render() {
        return (
            <>
                {/*Sản phẩm*/}
                <div className="row form-group mt-4">
                    <div className="col-md-3 text-right font-weight-bold">Chọn VPS</div>
                    <div className="col-md-8">
                        <Select
                            options={this.props.listVps}
                            onChange={ this.props.choosseVps() }
                            className="basic-single"
                            classNamePrefix="select"
                            placeholder={'Chọn VPS'}
                        />
                    </div>
                </div>
                {/*Addon*/}
                <div className="row form-group mt-4">
                    {
                        this.props.isFormAddon ? (
                            <>
                                <div className="col-md-3 text-right font-weight-bold">Thời gian thuê</div>
                                <div className="col-md-8">
                                    <Select
                                        options={this.props.listBillingCycle}
                                        onChange={ this.props.choosseBillingCycle() }
                                        className="basic-single"
                                        classNamePrefix="select"
                                        placeholder={'Chọn thời gia hạn'}
                                    />
                                </div>
                            </>
                        ) : (
                            <></>
                        )
                    }
                </div>
                {/*  Trừ tiền tài khoản  */}
                {
                    this.props.status === 'Finish' ? (
                        <div className="row form-group mt-4">
                            <div className="col-md-3 text-right font-weight-bold">Trừ tiền tài khoản</div>
                            <div className="col-md-8">
                                <input type="checkbox" name="minusCredit" onChange={ this.changeInput } value={ this.props.minusCredit } />
                            </div>
                        </div>
                    ) : (
                        <></>
                    )
                }
            </>
        );
    }
}

export default CreateOrderExpireVpsComponent;